import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { GurdServiceService } from 'src/app/Service/gurd-service.service';
import { NotificationService } from 'src/app/Service/notification.service';
import { OtherService } from 'src/app/Service/other.service';
import { ActivatedRoute, Router } from '@angular/router';
import axios from 'src/app/Service/axios';
import momentJalaali from 'moment-jalaali';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-load-watch-energy',
  templateUrl: './load-watch-energy.component.html',
  styleUrls: ['./load-watch-energy.component.css', '../load-watch-performance/load-watch-performance.component.css']
})

export class LoadWatchEnergyComponent implements OnInit {
  reportEnergy: any;
  totalRunTimeSec: number = 0;
  totalEnergyProduced: number = 0;
  totalOverloadDurationSec: number = 0;
  totalIdleRunTimeSec: number = 0;
  totalLoadedRunTimeSec: number = 0;
  strTotalRunTimeSec: string = '';
  strTotalOverloadDurationSec: string = '';
  strTotalIdleRunTimeSec: string = '';
  strTotalLoadedRunTimeSec: string = '';

  searchForm: FormGroup = this._formBuilder.group({
    strSession: new FormControl(this._gurd.decrypt(localStorage.getItem('Session')!)),
    iSystemUser: new FormControl(this._gurd.decrypt(localStorage.getItem('ID')!)),
    strIMEI: new FormControl(''),
    strSDate: new FormControl(momentJalaali().subtract(30, 'day').format('jYYYY/jMM/jDD')),
    strEDate: new FormControl(momentJalaali().subtract(1, 'day').format('jYYYY/jMM/jDD')),
  });

  constructor(
    private _tooltip: NotificationService,
    private _formBuilder: FormBuilder,
    private _gurd: GurdServiceService,
    public _other: OtherService,
    private _router: Router,
    private route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    const id = this.route.snapshot.parent?.params['id'];

    this.searchForm.patchValue({
      strIMEI: id
    })

    // this.reportEnergy = [
    //   {
    //     strDate: '1405/05/10',
    //     DayName: 'شنبه',
    //     strSTime: '08:00',
    //     strETime: '16:00',
    //     strRunTimeSec: '08:00:00',
    //     fEnergyProduced: 1250.5,
    //     fAvgActivePower: 156.3,
    //     fMaxActivePower: 180.0,
    //     fMinLoadPercent: 15.2,
    //     fMaxLoadPercent: 85.5,
    //     fAvgPowerFactor: 65.0,
    //     strOverloadDurationSec: '00:15:00',
    //     strIdleRunTimeSec: '01:30:00',
    //     strLoadedRunTimeSec: '06:15:00'
    //   },
    //   {
    //     strDate: '1405/05/11',
    //     DayName: 'یکشنبه',
    //     strSTime: '09:30',
    //     strETime: '18:30',
    //     strRunTimeSec: '09:00:00',
    //     fEnergyProduced: 1420.0,
    //     fAvgActivePower: 157.7,
    //     fMaxActivePower: 195.2,
    //     fMinLoadPercent: 20.0,
    //     fMaxLoadPercent: 92.0,
    //     fAvgPowerFactor: 72.5,
    //     strOverloadDurationSec: '00:45:00',
    //     strIdleRunTimeSec: '00:45:00',
    //     strLoadedRunTimeSec: '07:30:00'
    //   },
    //   {
    //     strDate: '1405/05/12',
    //     DayName: 'دوشنبه',
    //     strSTime: '07:15',
    //     strETime: '12:15',
    //     strRunTimeSec: '05:00:00',
    //     fEnergyProduced: 850.2,
    //     fAvgActivePower: 170.0,
    //     fMaxActivePower: 210.5,
    //     fMinLoadPercent: 25.5,
    //     fMaxLoadPercent: 98.0,
    //     fAvgPowerFactor: 80.1,
    //     strOverloadDurationSec: '01:10:00',
    //     strIdleRunTimeSec: '00:20:00',
    //     strLoadedRunTimeSec: '03:30:00'
    //   },
    //   {
    //     strDate: '1405/05/13',
    //     DayName: 'سه‌شنبه',
    //     strSTime: '10:00',
    //     strETime: '22:00',
    //     strRunTimeSec: '12:00:00',
    //     fEnergyProduced: 2100.8,
    //     fAvgActivePower: 175.0,
    //     fMaxActivePower: 220.0,
    //     fMinLoadPercent: 30.0,
    //     fMaxLoadPercent: 95.5,
    //     fAvgPowerFactor: 78.4,
    //     strOverloadDurationSec: '02:00:00',
    //     strIdleRunTimeSec: '01:00:00',
    //     strLoadedRunTimeSec: '09:00:00'
    //   },
    //   {
    //     strDate: '1405/05/14',
    //     DayName: 'چهارشنبه',
    //     strSTime: '06:00',
    //     strETime: '14:00',
    //     strRunTimeSec: '08:00:00',
    //     fEnergyProduced: 1100.0,
    //     fAvgActivePower: 137.5,
    //     fMaxActivePower: 160.0,
    //     fMinLoadPercent: 10.0,
    //     fMaxLoadPercent: 75.0,
    //     fAvgPowerFactor: 55.0,
    //     strOverloadDurationSec: '00:00:00',
    //     strIdleRunTimeSec: '02:00:00',
    //     strLoadedRunTimeSec: '06:00:00'
    //   }
    // ];

  }

  fetchData = async (showLoading: boolean = true) => {
    let model = this.searchForm.value;

    if (showLoading) {
      this._other.Showspinner()
    }

    let res = JSON.parse((await axios.post(`LoadWatch_DailyReport_Performance`, this._other.stringNumberToNumber(model))).data.toString());
    this._other.nonespinner();

    if (res.ISSessionExpired == true) {
      this._tooltip.showError('لطفا وارد سیستم شوید');
      this._other.removeLocalStorage();
      this._router.navigate(['login'], { queryParams: { error: '3' } });
      return;
    }

    if (res.iResult == 0) {
      return this._tooltip.showError(res.strError);
    }

    this.reportEnergy = res;
    this.calculateTotals();

  }

  calculateTotals() {
    this.totalRunTimeSec = 0;
    this.totalEnergyProduced = 0;
    this.totalOverloadDurationSec = 0;
    this.totalIdleRunTimeSec = 0;
    this.totalLoadedRunTimeSec = 0;

    for (const item of this.reportEnergy) {
      this.totalRunTimeSec += parseInt(item.iRunTimeSec ?? 0);
      this.totalEnergyProduced += parseFloat(item.fEnergyProduced ?? 0);
      this.totalOverloadDurationSec += parseInt(item.iOverloadDurationSec ?? 0);
      this.totalIdleRunTimeSec += parseInt(item.iIdleRunTimeSec ?? 0);
      this.totalLoadedRunTimeSec += parseInt(item.iLoadedRunTimeSec ?? 0);
    }

    this.totalEnergyProduced = Number(this.totalEnergyProduced.toFixed(2));

    this.strTotalRunTimeSec = this.secondsToHMS(this.totalRunTimeSec);
    this.strTotalOverloadDurationSec = this.secondsToHMS(this.totalOverloadDurationSec);
    this.strTotalIdleRunTimeSec = this.secondsToHMS(this.totalIdleRunTimeSec);
    this.strTotalLoadedRunTimeSec = this.secondsToHMS(this.totalLoadedRunTimeSec);
  }

  secondsToHMS(totalSeconds: any) {
    const h = Math.floor(totalSeconds / 3600);
    const m = Math.floor((totalSeconds % 3600) / 60);
    const s = totalSeconds % 60;
    return `${h}:${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`;
  }

  exportExcel(): void {
    let element = document.getElementById("Export_Excel");
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);

    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    XLSX.writeFile(wb, 'انرژی ژنراتور.xlsx');
  }

}